import { defineMessages } from 'react-intl';

const messages = defineMessages({
  backButton: {
    id: 'profiles.exitOrganizationWizard.backButton',
    defaultMessage: 'Back',
  },
  cancelButton: {
    id: 'profiles.exitOrganizationWizard.cancelButton',
    defaultMessage: 'Cancel',
  },
  clientsStepAllowAccessLabel: {
    id: 'profiles.exitOrganizationWizard.clientsStepAllowAccessLabel',
    defaultMessage:
      'Let clients keep access to content already assigned to them',
  },
  clientsStepDescription: {
    id: 'profiles.exitOrganizationWizard.clientsStepDescription',
    defaultMessage:
      'Choose what happens to workouts, programs and other content already assigned to your clients through Schedule. Their history is kept either way.',
  },
  clientsStepTitle: {
    id: 'profiles.exitOrganizationWizard.clientsStepTitle',
    defaultMessage: 'Clients',
  },
  confirmButtonClose: {
    id: 'profiles.exitOrganizationWizard.confirmButtonClose',
    defaultMessage: 'Close organization',
  },
  confirmButtonLeave: {
    id: 'profiles.exitOrganizationWizard.confirmButtonLeave',
    defaultMessage: 'Leave organization',
  },
  confirmStepTitle: {
    id: 'profiles.exitOrganizationWizard.confirmStepTitle',
    defaultMessage: 'Confirm',
  },
  confirmSummaryClientsAllow: {
    id: 'profiles.exitOrganizationWizard.confirmSummaryClientsAllow',
    defaultMessage: 'Clients keep access to content already assigned to them.',
  },
  confirmSummaryClientsDeny: {
    id: 'profiles.exitOrganizationWizard.confirmSummaryClientsDeny',
    defaultMessage: 'Clients lose access to content already assigned to them.',
  },
  confirmSummaryContentKeep: {
    id: 'profiles.exitOrganizationWizard.confirmSummaryContentKeep',
    defaultMessage: 'Your content stays with this organization.',
  },
  confirmSummaryContentTransfer: {
    id: 'profiles.exitOrganizationWizard.confirmSummaryContentTransfer',
    defaultMessage:
      'Your content moves to {organizationName}. Any marketplace listing is removed.',
  },
  confirmSummaryContentCopy: {
    id: 'profiles.exitOrganizationWizard.confirmSummaryContentCopy',
    defaultMessage:
      'A copy of your content is created in {organizationName}. The originals stay with this organization.',
  },
  contentStepCopyNote: {
    id: 'profiles.exitOrganizationWizard.contentStepCopyNote',
    defaultMessage:
      'Copies are created in the other organization — your originals stay here. Marketplace listings are not copied.',
  },
  contentStepCopyOption: {
    id: 'profiles.exitOrganizationWizard.contentStepCopyOption',
    defaultMessage: 'Copy it to my organization (keep the originals here)',
  },
  contentStepCreateProfileLink: {
    id: 'profiles.exitOrganizationWizard.contentStepCreateProfileLink',
    defaultMessage: 'Create a new organization or PT profile',
  },
  contentStepDescription: {
    id: 'profiles.exitOrganizationWizard.contentStepDescription',
    defaultMessage:
      'Decide what happens to the workouts, programs and other content you authored here. Co-authored or shared courses stay with this organization.',
  },
  contentStepKeepOption: {
    id: 'profiles.exitOrganizationWizard.contentStepKeepOption',
    defaultMessage: 'Leave it with this organization',
  },
  contentStepMarketplaceNote: {
    id: 'profiles.exitOrganizationWizard.contentStepMarketplaceNote',
    defaultMessage:
      'Any marketplace listing on transferred content is removed — you can re-list it from the new organization afterwards.',
  },
  contentStepNoTargetOrg: {
    id: 'profiles.exitOrganizationWizard.contentStepNoTargetOrg',
    defaultMessage:
      "You don't have another organization or PT profile to transfer content into.",
  },
  contentStepSelectTargetLabel: {
    id: 'profiles.exitOrganizationWizard.contentStepSelectTargetLabel',
    defaultMessage: 'Target organization',
  },
  // Q3/Task 4: TWO states lock an organization and they say opposite things
  // about the customer. This row renders inline from the organization itself,
  // which carries the lock REASON, so it names the right one.
  targetBillingLocked: {
    id: 'profiles.exitOrganizationWizard.targetBillingLocked',
    defaultMessage: 'Temporarily unavailable (unpaid balance)',
  },
  // Deliberately not "temporarily": a cancelled plan stays until someone
  // chooses a plan again.
  targetSubscriptionEnded: {
    id: 'profiles.exitOrganizationWizard.targetSubscriptionEnded',
    defaultMessage: 'Unavailable (subscription ended)',
  },
  contentStepStepTitle: {
    id: 'profiles.exitOrganizationWizard.contentStepStepTitle',
    defaultMessage: 'Content',
  },
  contentStepTransferOption: {
    id: 'profiles.exitOrganizationWizard.contentStepTransferOption',
    defaultMessage: 'Transfer it to my organization',
  },
  exportError: {
    id: 'profiles.exitOrganizationWizard.exportError',
    defaultMessage: 'Could not download the report.',
  },
  exportStepDescription: {
    id: 'profiles.exitOrganizationWizard.exportStepDescription',
    defaultMessage:
      'Before you go, you can download a CSV report of this organization’s work data for your records.',
  },
  exportStepDownloadButton: {
    id: 'profiles.exitOrganizationWizard.exportStepDownloadButton',
    defaultMessage: 'Download report (CSV)',
  },
  exportStepTitle: {
    id: 'profiles.exitOrganizationWizard.exportStepTitle',
    defaultMessage: 'Export',
  },
  nextButton: {
    id: 'profiles.exitOrganizationWizard.nextButton',
    defaultMessage: 'Next',
  },
  postExitOfferAddProfile: {
    id: 'profiles.exitOrganizationWizard.postExitOfferAddProfile',
    defaultMessage: 'Add profile',
  },
  postExitOfferDescription: {
    id: 'profiles.exitOrganizationWizard.postExitOfferDescription',
    defaultMessage:
      "You're no longer an owner or trainer of any organization. Would you like to create your own organization or PT profile?",
  },
  postExitOfferDismiss: {
    id: 'profiles.exitOrganizationWizard.postExitOfferDismiss',
    defaultMessage: 'No thanks',
  },
  postExitOfferTitle: {
    id: 'profiles.exitOrganizationWizard.postExitOfferTitle',
    defaultMessage: 'Create your own profile?',
  },
  skipButton: {
    id: 'profiles.exitOrganizationWizard.skipButton',
    defaultMessage: 'Skip',
  },
  stepOf: {
    id: 'profiles.exitOrganizationWizard.stepOf',
    defaultMessage: 'Step {current} of {total}',
  },
  wizardTitleClose: {
    id: 'profiles.exitOrganizationWizard.wizardTitleClose',
    defaultMessage: 'Close organization',
  },
  wizardTitleLeave: {
    id: 'profiles.exitOrganizationWizard.wizardTitleLeave',
    defaultMessage: 'Leave organization',
  },
});

export default messages;
